import {
    FETCH_ASSOCIATED_PARTIES_DATA_SUCCESS,
    UPDATE_ASSOCIATED_PARTIES_DATA_SUCCESS,
    RESET_ASSOCIATED_PARTIES,
    FETCH_CREATE_PARTY_DATA_SUCCESS,
    FETCH_PARTY_INFO_SUCCESS,
    FETCH_PARTY_SUGGESTION_SUCCESS,
    CHANGE_LOG_ASSOCIATE_PARTY_SUCCESS,
    ADD_ASSOCIATE_PARTY_ERROR,
    RESET_PARTY_SUGGESTIONS,
    EDIT_PARTY_SUCCESS,
    RESET_EDIT_PARTY_DATA,
    SET_PARTY_ASSOCIATION,
    HIDE_PARTIES_LOADER,
    SHOW_PARTIES_LOADER,
    DELETE_ASSOCIATE_PARTY_SUCCESS,
    FETCH_PARTY_STATES_SUCCESS,
    FETCH_CARRIER_LIST_SUCCESS

} from "../actions/actionConstants";
import {mergeArrayByKey} from "../../../common/util";

const initialState = {
    isLoading:false,
    createPartyData: {},
    associatedPartiesData:{
        activeTab:0
    },
    partyInfo:{},
    partySuggestions: [],
    changeLogData :{},
    editPartyData: {},
    associateWith: null,
    mailingStates:[],
    billingStates:[],
    carrierList:[]
}

function updateAssociatedPartiesByFilter(data,reduxData){
    if(data.partyitem.length > 0){
        let res=data;
        data.partyitem.map((item,key)=>{
            const filteredData=reduxData.partyitem.filter(rItem => rItem.filter==item.filter);
            if(filteredData.length > 0){
                const arr= filteredData.map((data,index)=>{
                    const arr = mergeArrayByKey(data.partyitems,item.partyitems,'party_id');
                    return Object.assign({},item,{partyitems:arr})
                });
                const reduxarr = mergeArrayByKey(reduxData.partyitem, arr , 'filter');
                res = Object.assign({}, data, { partyitem: reduxarr})
            }
            else if(!(JSON.stringify(res)===JSON.stringify(data))){
                const arr= mergeArrayByKey(res.partyitem,[item],'filter');
                res=Object.assign({},data,{partyitem:arr})
            }
            else{
                const arr= mergeArrayByKey(reduxData.partyitem,[item],'filter');
                res=Object.assign({},data,{partyitem:arr})
            }
        });
        return res;
    }
    else{
        return reduxData;
    }
}

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_ASSOCIATED_PARTIES_DATA_SUCCESS: 
            return Object.assign({}, state, {associatedPartiesData: action.payload});

        case UPDATE_ASSOCIATED_PARTIES_DATA_SUCCESS:
            let partiesData={};
            partiesData=updateAssociatedPartiesByFilter(action.payload.Data,state.associatedPartiesData.Data);
            const partiesDataObj={
                activeTab:action.payload.activeTab,
                Data:partiesData,
                skip:action.payload.skip,
                take:action.payload.take,
                Total:action.payload.Total,
                status:action.payload.status
            };

            return Object.assign({}, state,{associatedPartiesData: partiesDataObj});

        case RESET_ASSOCIATED_PARTIES:
            return Object.assign(
                {},
                initialState,
                {
                    associateWith: state.associateWith,
                    createPartyData:state.createPartyData,
                    mailingStates:state.partyStates, 
                    billingStates: state.billingStates
                }
            );  
             
        case FETCH_CREATE_PARTY_DATA_SUCCESS: {
            return Object.assign({}, state, {
                createPartyData: action.payload
            });
        }

        case FETCH_CARRIER_LIST_SUCCESS: {            
            return Object.assign({}, state, {
                carrierList: action.payload.carrierList
            });
        }

        case FETCH_PARTY_INFO_SUCCESS:
            return Object.assign({},state,{partyInfo:action.payload});

        case FETCH_PARTY_STATES_SUCCESS:
            if(action.listType == 0){
                return Object.assign({}, state, { mailingStates: action.payload });
            } else if (action.listType == 1){
                return Object.assign({}, state, { billingStates: action.payload });
            } else {
                return Object.assign({}, state, { mailingStates: action.payload, billingStates: action.payload });
            }

        case FETCH_PARTY_SUGGESTION_SUCCESS: 
            return Object.assign({},state,{partySuggestions:action.payload});            
        
        case RESET_PARTY_SUGGESTIONS:
            return Object.assign({},state,{partySuggestions:[]});            

        case ADD_ASSOCIATE_PARTY_ERROR:
            const associatedPartiesData = Object.assign({}, state.associatedPartiesData, action.payload);
            return Object.assign({}, state, {associatedPartiesData: associatedPartiesData});

        case CHANGE_LOG_ASSOCIATE_PARTY_SUCCESS:
            return Object.assign({},state,{changeLogData:action.payload});

        case EDIT_PARTY_SUCCESS:
            return Object.assign({},state,{
                editPartyData:action.payload.editPartyData,
                createPartyData:action.payload.createPartyData,
            });

        case RESET_EDIT_PARTY_DATA: 
            return Object.assign({},state,{editPartyData: {}});      
            
        case SET_PARTY_ASSOCIATION: 
            return Object.assign({}, state, {associateWith: action.payload});

        case HIDE_PARTIES_LOADER:
            return Object.assign({}, state, {isLoading: false})
        case SHOW_PARTIES_LOADER:
            return Object.assign({}, state, {isLoading: true});

        case DELETE_ASSOCIATE_PARTY_SUCCESS:
            const {id} = action.payload;

            let updatesRes = Object.assign({},
                state,
                {
                    associatedPartiesData: Object.assign(
                        {},
                        state.associatedPartiesData,
                        {
                            Data : Object.assign(
                            {},
                            state.associatedPartiesData.Data,
                            {
                                partyitem : state.associatedPartiesData.Data.partyitem.map((data) => {
                                    const res= Object.assign({}, data, { partyitems: data['partyitems'].filter(item=>item.party_id!=id) } ) ;
                                    if(res.partyitems.length > 0)
                                        return res;
                                    }).filter(item=>item!=undefined)
                             }
                        )}
                    )
                }
            )
            return Object.assign({},state,updatesRes);
            
        default:
            return state;
    }
}